import GroupResource from './group-resource';
import JsonApiReference from './jsonapi-reference';
import JsonApiResource from './jsonapi-resource';
import ManufacturerResource from './manufacturer-resource';
import ReferenceResolver from './reference-resolver';

export default class SiteResource extends GroupResource {
  name: string = null;
  account: string = null;
  address: string = null;
  defaults: any = null;
  state: string = null;
  country: string = null;
  zipcode: string = null;
  timeZone: string = null;
  manufacturer: ManufacturerResource = new ManufacturerResource();
  permissions: any[] = [];

  relationships = {
    manufacturer: '=chemical-manufacturer',
    permissions: '<',
    defaults: '!'
  };

  constructor(init?: Partial<SiteResource>) {
    super(init, 'sites');
    this.initialize(init);
    if (init && init.manufacturer) {
      this.manufacturer = new ManufacturerResource(init.manufacturer);
    }
  }
}



// WEBPACK FOOTER //
// ./common/models/site-resource.ts